import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import PropTypes from 'prop-types';
import _ from 'lodash';
import WindowResizeListener from 'react-window-size-listener';
import VideoContainer from 'components/VideoContainer';
import classNames from 'classnames';
import {
  fireFloodlightEvent,
  getSegmentSourceName,
  getSegmentSourceType,
  trackPageReferrerAnalytics,
} from '@foxcorp/delta-web-analytics';
import { setRecommendationIdAction as setRecommendationId } from 'index/AppActions';
import {
  forceKeyartForShowcase as forceCollectionKeyartForShowcase,
  updateShowcaseVideo,
} from 'screens/Collection/Actions';
import { noop } from 'helpers/GlobalHelper';
import { getDmaFromVideo } from 'helpers/AuthHelper';
import Video from 'components/VideoPlayer';
import VideoPlaylist from 'componentsV2/VideoPlaylist';
import {
  isMobileBreakpoint,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  DEBOUNCE_TIME,
} from 'helpers/BreakpointHelper';
import {
  getLocation,
  helperGetHomeUrl,
  helperGoToRelativeUrl,
  helperGetLiveUrl,
  helperGetVideoUrl,
} from 'helpers/RouteHelper';
import {
  getAuthForPanelVideo,
  getAuthorizingNetwork,
  getNetworkList,
  getRequiresAuth,
  isClip,
  isEpisode,
  isLive,
  isUngatedVideo,
} from 'helpers/ContentHelper';
import {
  CONTINUOUS,
  PLAYER_REFERENCE_GLOBAL,
  getPlayerCsid,
  isPlayerTypeHero,
  isPreviewPass,
  PLAYER_CONTEXT_LIVE,
  PLAYER_CONTEXT_WATCH,
  playerRemove,
  playerSetUserActive,
  PLAYLIST,
  RESTART,
  updatePlayerType,
  getPercentComplete,
} from 'helpers/PlayerHelper';
import {
  RELEASE_TYPE_LIVE,
  RESTART_TYPE_LIVE,
  VIDEO_TYPE_CLIP,
  VIDEO_TYPE_FULLEPISODE,
  VIDEO_TYPE_MOVIE,
  VIDEO_TYPE_GAME,
} from 'screens/Watch/WatchHelpers';
import { getPlaylistVariantActive } from 'helpers/AmplitudeHelper';
import { nationDigitalChannelEnabled, isEpgv2Enabled } from 'helpers/ConfigHelper';
import {
  clearNextVideosValidFor,
  clearPercentWatched,
  clearVideo,
  fetchNextVideo,
  fetchUpNext,
  fetchVideo,
  fetchVideoPanel,
  playNextPlaylistVideo,
  resetVodSectionClicked,
  saveLiveRestart,
  savePercentWatched,
  setError,
  setHasSeenHalfAnyVideo,
  setPortalContentFinished,
  setStreamExit,
  setVideoPanel,
  setVideoStartedPlayback,
} from './Actions';
import {
  getShouldCheckPreviewPass,
  getShouldDisablePreviewPassRender,
  getVideoContainerTheme,
} from './Helper';
import { DynamicRating, LiveContext, WatchContext } from './components';
import defaultStyle from './VideoPlayerGlobal.module.scss';
import heroStyle from './VideoPlayerGlobalHero.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: true,
  },
  [SITE_PLATFORM_WEB]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: true,
  },
  [SITE_PLATFORM_TABLET]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: false,
  },
};
const CONTAINER_ID = 'video-player-container';
let autoplayTimeout;
let exitStreamTimeout;
class VideoPlayerGlobal extends Component {
  constructor(props) {
    super(props);
    const mode = _.get(this.props, 'params.modeId', '');
    const hash = _.trim(_.get(this.props, 'location.hash'), '#');
    const isRestart = mode === RESTART || _.includes(hash, RESTART);
    const isContinuous = _.includes(hash, CONTINUOUS);
    const isPlaylist = _.includes(hash, PLAYLIST);
    const playlistId = isPlaylist ? hash.replace(`${PLAYLIST}=`, '') : null;
    const playerType = _.get(this.props, 'playerType');
    const theme = isPlayerTypeHero(playerType) ? heroStyle : defaultStyle;

    this.state = {
      adPlaying: false,
      adPodStarted: null,
      clickedEndSlate: false,
      clickedThumbnail: false,
      containerId: CONTAINER_ID,
      continuous: isContinuous || isPlaylist,
      continuousPlayback: true,
      creditsPlaying: false,
      entitlementIssues: null,
      firePlayerPageViews: false,
      firstAdPlayed: false,
      firstFramePlayed: false,
      isAuthError: null,
      isAutoPlay: null,
      isNationDigitalChannel: nationDigitalChannelEnabled(),
      isVideoOverlayPresent: false,
      mediaComplete: false,
      mediaEnding: false,
      mediaEndingSeconds: null,
      mediaStarted: false,
      playerDataHover: false,
      playerLoading: true,
      playlist: playlistId,
      preAuthCheckComplete: false,
      restart: isRestart,
      segmentReferrer: null,
      segmentSourceName: null,
      segmentSourceType: null,
      showControls: true,
      showEndCards: true,
      showRestartOverlay: false,
      showTrailerUpsell: false,
      showTVRating: false,
      stillWatchingHideTimeout: null,
      stillWatchingShowTimeout: null,
      streamExit: false,
      theme,
      videoContainerHeight: 0,
    };

    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { clickedEndSlate, clickedThumbnail } = this.state;
    const {
      clearPercentWatched,
      errors,
      panelVideo,
      originalItem,
      resetVodSectionClicked,
      restartVideo,
      video,
    } = this.props;
    const {
      errors: nextErrors,
      panelVideo: nextPanelVideo,
      originalItem: nextOriginalItem,
      restartVideo: nextRestartVideo,
      video: nextVideo,
    } = nextProps;
    const videoId = _.get(video, 'id');
    const nextVideoId = _.get(nextVideo, 'id');
    let newState = {};

    if (nextOriginalItem && nextOriginalItem !== originalItem) {
      resetVodSectionClicked();
      this.triggerSegmentPlayerSectionSource({ originalItem: nextOriginalItem });
    }

    if (this.videoContainerEl) {
      this.setState({ videoContainerHeight: this.videoContainerEl.clientHeight });
    }

    if (videoId && videoId !== nextVideoId) {
      newState.prevVideo = video;
      newState.adPlaying = false;
      newState.showControls = true;
      if (!clickedEndSlate && !clickedThumbnail) {
        const analyticsLocation = getLocation(window.referrer);
        const { pathname: path } = analyticsLocation;
        const newSegmentSourceType = getSegmentSourceType({
          homeUrl: helperGetHomeUrl(),
          path,
          vodThumbnails: clickedThumbnail,
        });
        const segmentSourceName = getSegmentSourceName({
          data: video,
          type: newSegmentSourceType,
        });
        newState = {
          ...newState,
          segmentSourceName,
          segmentSourceType: newSegmentSourceType,
        };
      }
    }

    if (nextErrors !== errors) {
      newState.entitlementIssues = nextErrors && _.isArray(nextErrors) ? nextErrors : null;
    }

    const screenUrl = this.getScreenUrl(panelVideo);
    const nextScreenUrl = this.getScreenUrl(nextPanelVideo);
    const screenUrlChanged = screenUrl && screenUrl !== nextScreenUrl;
    const restartVideoChanged = restartVideo !== nextRestartVideo;
    if (screenUrlChanged || restartVideoChanged) {
      newState.preAuthCheckComplete = false;
    }

    const panelVideoId = _.get(panelVideo, 'id');
    const nextPanelVideoId = _.get(nextPanelVideo, 'id');
    if (panelVideoId !== nextPanelVideoId) clearPercentWatched();

    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      accessToken,
      authSuccess,
      clearTimeout,
      clearVideo,
      deviceId,
      fetchVideo,
      forceCollectionKeyartForShowcase,
      isFreemium,
      panelVideo,
      playerType,
      provider,
      setTimeout,
      setVideoStartedPlayback,
      startedPlayback,
      video,
    } = this.props;
    const {
      authSuccess: prevAuthSuccess,
      startedPlayback: prevStartedPlayback,
      playerType: prevPlayerType,
      video: prevVideo,
    } = prevProps;
    const { preAuthCheckComplete } = this.state;
    const { preAuthCheckComplete: prevPreAuthCheckComplete } = prevState;
    const isHeroPlayer = isPlayerTypeHero(playerType);
    const screenUrl = this.getScreenUrl(panelVideo);
    const mvpd = _.get(provider, 'adobePassId');
    const autoplayContent = _.get(panelVideo, 'autoplayContent');
    const mvpdIsValidForPlayback = isHeroPlayer ? !isPreviewPass(mvpd) : true;
    const preAuthCheckCompleteChanged = preAuthCheckComplete !== prevPreAuthCheckComplete;
    const authSuccessChanged = authSuccess !== prevAuthSuccess;
    const contentChanged = authSuccessChanged || preAuthCheckCompleteChanged;
    const hasRequiredAuthData = preAuthCheckComplete && authSuccess && accessToken;
    const canFetchVideo = isHeroPlayer ? autoplayContent : true;
    const shouldFetchVideo =
      screenUrl && hasRequiredAuthData && contentChanged && mvpdIsValidForPlayback;
    const setAutoplayTimeout = !prevStartedPlayback && startedPlayback && isHeroPlayer;
    const playerTypeChanged = playerType !== prevPlayerType && playerType;
    const videoCleared = prevVideo && !video;
    let nextState = {};

    if (playerTypeChanged) {
      updatePlayerType(playerType, PLAYER_REFERENCE_GLOBAL);
      const nextTheme = isHeroPlayer ? heroStyle : defaultStyle;
      const clearAutoplayTimeout = isPlayerTypeHero(prevPlayerType) && !isHeroPlayer;
      if (clearAutoplayTimeout) clearTimeout(autoplayTimeout);
      nextState = {
        ...nextState,
        theme: nextTheme,
      };
    }

    if (setAutoplayTimeout) {
      const { autoplayIdleLimitSeconds } = window.ExternalConfig;
      if (autoplayIdleLimitSeconds) {
        const timeoutInMilliseconds = autoplayIdleLimitSeconds * 1000;
        clearTimeout(autoplayTimeout);
        autoplayTimeout = setTimeout(() => {
          forceCollectionKeyartForShowcase(true);
          clearVideo();
        }, timeoutInMilliseconds);
      }
    }

    if (shouldFetchVideo) {
      setVideoStartedPlayback(false);
      if (canFetchVideo) {
        const panelType = _.get(panelVideo, '@type');
        const videoGuid = _.get(panelVideo, 'guid');
        const audioOnly = _.get(panelVideo, 'audioOnly');
        const isLivePanel = isLive(panelType);
        const hash = _.trim(_.get(this.props, 'location.hash'), '#');
        const isPlaylist = _.includes(hash, PLAYLIST);
        const newPlaylistId = isPlaylist ? hash.replace(`${PLAYLIST}=`, '') : null;
        const { playlist } = prevState;
        let newScreenUrl = screenUrl;
        if (screenUrl && newPlaylistId && playlist !== newPlaylistId) {
          const prependCharacter = screenUrl.includes('?') ? '&' : '?';
          newScreenUrl = `${screenUrl}${prependCharacter}${PLAYLIST}=${newPlaylistId}`;
          nextState = { ...nextState, playlist: newPlaylistId };
        }
        const options = {
          url: newScreenUrl,
          isLive: isLivePanel,
          isFreemium,
          accessToken,
          deviceId,
          videoGuid,
          audioOnly,
          panelVideo,
        };
        fetchVideo(options);
      }
    }

    if (shouldFetchVideo || videoCleared) {
      nextState = {
        ...nextState,
        creditsPlaying: false,
        firstFramePlayed: false,
        isAuthError: false,
        mediaComplete: false,
        mediaEnding: false,
        mediaEndingSeconds: null,
        playerLoading: true,
      };
    }
    this.setUserAtrribute50PercentViewed(video, PLAYER_REFERENCE_GLOBAL);

    if (!_.isEmpty(nextState)) this.setState(nextState);
  }

  componentWillUnmount() {
    const { clearVideo } = this.props;
    clearVideo();
    this.clearTimeouts();
  }

  onExitEventStream = e => {
    const { setTimeout } = this.props;
    const timeout = _.get(e, 'exitEventStreamSlateDuration', 30);
    exitStreamTimeout = setTimeout(() => {
      this.setState({ streamExit: true });
    }, timeout * 1000);
  };

  getDefaultPlayerEvents = () => ({
    onPlayerLoadComplete: () => {
      const { isAuthError: lclIsAuthError } = this.state;
      this.setState({ playerLoading: false });
      if (lclIsAuthError) playerRemove(PLAYER_REFERENCE_GLOBAL);
    },
    onShowControls: e => {
      const { showControls: oldShowControls, isAuthError: lclIsAuthError } = this.state;

      if (oldShowControls !== e && !lclIsAuthError) {
        this.setState({ showControls: e });
      }
    },
    onReleaseCleared: e => {
      const { clearVideo, forceCollectionKeyartForShowcase, playerType } = this.props;
      const { reason } = e;
      const isPlayerHero = isPlayerTypeHero(playerType);
      if (reason === 'concurrency' && isPlayerHero) {
        forceCollectionKeyartForShowcase(true);
        clearVideo();
        this.clearTimeouts();
      } else if (e) this.setState({ isVideoOverlayPresent: true });
    },
    // TODO: move to live context
    onExitEventStream: e => {
      this.onExitEventStream(e);
    },
  });

  getDefaultVideoContainerProps = item => {
    const {
      adPlaying,
      entitlementIssues,
      playerLoading,
      showControls,
      showTrailerUpsell,
      stickyControls,
      playerDataHover,
    } = this.state;
    const {
      accessToken,
      account,
      adblock,
      anonymousAccount,
      anonymousId,
      anonymousLogin,
      authSuccess,
      blackoutConfig,
      blackoutDefinitions,
      breakpoint,
      deviceId,
      isLiveRestart,
      isStatic,
      isVodUnavailable,
      onAuthCheckComplete,
      panelVideo,
      playerType,
      preauthorizedResources,
      profileId,
      provider,
      releaseUrl,
      renderAuthContainer,
      setAuthorizationToken,
      setBlockMVPDIncomplete,
      setInterval,
      setIsAuthenticated,
      setIsPlayerLoaded,
      setMVPDToAppState,
      setOverlay,
      setProvider,
      toggleMvpdAuthOverlay,
      triggerAuthCheck,
      video,
    } = this.props;

    if (!item)
      return { breakpoint, renderAuthContainer, theme: getVideoContainerTheme(playerType) };

    const {
      scrubbingEnabled,
      videoType,
      contentRating,
      contentSKU,
      id: videoId,
      network,
      networks,
      showCode,
    } = item;
    const shouldShowControls = showControls || stickyControls || playerDataHover;
    const siteSection = getPlayerCsid({
      showCode,
      isFullEpisode: isEpisode(videoType),
    });
    const requiresAuth = getRequiresAuth({ video: panelVideo });
    const requiresAuthLive = getRequiresAuth({ video: panelVideo, isLive: true });
    const networkEntitlementList = getNetworkList();
    const authorizingNetwork = getAuthorizingNetwork(item, false, accessToken);
    const contentNetworks = networks || [network];
    const isClip = videoType === VIDEO_TYPE_CLIP;
    const scrubbingEnabledCalc = scrubbingEnabled || isClip;
    const containerClass = null;
    const shouldCheckPreviewPass = getShouldCheckPreviewPass(playerType);
    const disablePreviewPassRender = getShouldDisablePreviewPassRender(playerType);
    const props = {
      account,
      adblock,
      anonymousAccount,
      anonymousId,
      anonymousLogin,
      authSuccess,
      authorizingNetwork,
      backfade: (showControls || playerDataHover) && !adPlaying,
      blackoutConfig,
      blackoutDefinitions,
      breakpoint,
      containerClass,
      contentNetworks,
      contentRating,
      contentSKU,
      deviceId,
      entitlementIssues,
      isLiveRestart,
      isStatic,
      isVodUnavailable,
      isUngatedVideo: isUngatedVideo(panelVideo),
      network,
      networkEntitlementList,
      onAuthCheckComplete,
      playerLoading,
      playerType,
      preauthorizedResources,
      profileId,
      profileToken: accessToken,
      provider,
      reducerVideo: video,
      releaseURL: releaseUrl,
      renderAuthContainer,
      requiresAuth,
      requiresAuthLive,
      scrubbingEnabled: scrubbingEnabledCalc,
      selectedVideo: videoId,
      setAuthError: value => this.setState({ isAuthError: value }),
      setAuthorizationToken,
      setBlockMVPDIncomplete,
      setInterval,
      setIsAuthenticated,
      setIsPlayerLoaded,
      setMVPDToAppState,
      setOverlay,
      setPlayerDataHover: this.setPlayerDataHover,
      setPreAuthCheckComplete: this.setPreAuthCheckComplete,
      setProvider,
      setStickyControls: this.setStickyControls,
      showTrailerUpsell,
      shouldCheckPreviewPass,
      disablePreviewPassRender,
      showControls: shouldShowControls,
      siteSection,
      theme: getVideoContainerTheme(playerType),
      toggleMvpdAuthOverlay,
      triggerAuthCheck,
      videoId,
      videoType,
    };
    return props;
  };

  getScreenUrl = item => {
    const { playlist } = this.state;
    const { isLiveRestart } = this.props;

    const isLiveContent = this.isLiveContent(item) && !isLiveRestart;
    const screenUrlPath = isLiveContent ? 'livePlayerScreenUrl' : 'playerScreenUrl';
    let screenUrl = _.get(item, screenUrlPath);
    if (playlist && screenUrl) {
      const prependCharacter = screenUrl.includes('?') ? '&' : '?';
      const playlistParam = `${prependCharacter}${PLAYLIST}=${playlist}`;
      screenUrl = `${screenUrl}${playlistParam}`;
    }
    return screenUrl;
  };

  setPlayerDataHover = hover => {
    const { breakpoint } = this.props;
    const { playerMetadataOverlay } = BREAKPOINTS[breakpoint];
    if (playerMetadataOverlay) {
      this.setState({ playerDataHover: hover }, () => {
        this.setStickyControls(hover);
      });
    }
  };

  setPlayerDataHover = hover => {
    const { breakpoint } = this.props;
    const { playerMetadataOverlay } = BREAKPOINTS[breakpoint];
    if (playerMetadataOverlay) {
      this.setState({ playerDataHover: hover }, () => {
        this.setStickyControls(hover);
      });
    }
  };

  setPlayerState = (newState, cb) => {
    if (newState) this.setState(newState, cb);
  };

  setPreAuthCheckComplete = (value = true) => {
    this.setState({ preAuthCheckComplete: value });
  };

  setStickyControls = sticky => {
    const { playerDataHover } = this.state;
    this.setState({ stickyControls: sticky }, () => {
      playerSetUserActive(PLAYER_REFERENCE_GLOBAL, sticky || playerDataHover);
    });
  };

  setVideoOverlay = overlay => {
    this.setState({ isVideoOverlayPresent: overlay });
  };

  setUserAtrribute50PercentViewed = (video, playerReference) => {
    const { hasSeenHalfAnyVideo, setHasSeenHalfAnyVideo } = this.props;
    const { videoType = '', durationInSeconds } = video || {};
    if (!hasSeenHalfAnyVideo && !isClip(videoType)) {
      const percentComplete = getPercentComplete({ playerReference, durationInSeconds });
      if (percentComplete && percentComplete >= 50) setHasSeenHalfAnyVideo();
    }
  };

  clearTimeouts = () => {
    const { clearTimeout } = this.props;
    clearTimeout(autoplayTimeout);
    clearTimeout(exitStreamTimeout);
  };

  floodlightEvent = videoData => {
    const isLongForm = !isClip(_.get(videoData, 'videoType', ''));
    fireFloodlightEvent(videoData, isLongForm);
  };

  gotoLive = () => {
    const hash = _.trim(_.get(this.props, 'location.hash'), '#');
    const callSign = _.trim(hash.replace(RESTART_TYPE_LIVE, ''), '-');
    helperGoToRelativeUrl(helperGetLiveUrl({ callSign }));
  };

  isLiveContent = item => isLive(_.get(item, '@type'));

  triggerSegmentPlayerSectionSource = ({ originalItem } = {}) => {
    const originalItemId = _.get(originalItem, 'id');
    const currentId = _.get(this.props, 'video.id');
    if (originalItemId === currentId) return null;
    const {
      firstFramePlayed,
      segmentSourceType,
      segmentSourceName,
      mediaComplete,
      clickedThumbnail,
    } = this.state;
    if (firstFramePlayed && !mediaComplete) {
      const { video } = this.props;
      let newSegmentSourceName = segmentSourceName;
      let newSegmentSourceType = segmentSourceType;
      if (!newSegmentSourceName || !newSegmentSourceType) {
        const analyticsLocation = getLocation(window.referrer);
        const { pathname: path } = analyticsLocation;
        newSegmentSourceType = getSegmentSourceType({
          homeUrl: helperGetHomeUrl(),
          path,
          vodThumbnails: clickedThumbnail,
        });
        newSegmentSourceName = getSegmentSourceName({
          data: video,
          type: newSegmentSourceType,
        });
      }
    }
    return this.setState({ clickedThumbnail: originalItem });
  };

  renderDynamicRating = video => {
    if (!video) return null;

    const { showTVRating, playerLoading, adPlaying } = this.state;
    const { contentRating, releaseType, subRatings, showTvRatingOverlay, videoType } = video;
    const isLiveVideo = this.isLiveContent(video);

    if (!contentRating) return null;

    const shouldDisplayOverlayVOD = () => {
      const videoTypes = [VIDEO_TYPE_FULLEPISODE, VIDEO_TYPE_MOVIE, VIDEO_TYPE_GAME];
      const validVideoType = videoType && videoTypes.indexOf(videoType) !== -1;
      const isNotLive = releaseType !== RELEASE_TYPE_LIVE;
      return !!(showTVRating && showTvRatingOverlay && validVideoType && isNotLive);
    };

    const shouldDisplayOverlayLive = () =>
      !!(isLiveVideo && showTvRatingOverlay && !playerLoading && !adPlaying);

    const shouldDisplayOverlay = isLiveVideo
      ? shouldDisplayOverlayLive()
      : shouldDisplayOverlayVOD();
    if (!shouldDisplayOverlay) return null;
    return <DynamicRating rating={contentRating} subRatings={subRatings} />;
  };

  renderPlayer = () => {
    const {
      accessToken,
      isFreemium,
      nextVideos,
      page,
      panelVideo,
      playerContext,
      portalRef,
      retryErrors,
      subscriptionPaused,
      subscription,
      video,
    } = this.props;
    const { theme, isFullscreen, isNationDigitalChannel } = this.state;

    const playerReference = PLAYER_REFERENCE_GLOBAL;
    const panelType = _.get(panelVideo, '@type');
    const isLivePanel = isLive(panelType);

    const requiresAuthLive =
      isLivePanel && getAuthForPanelVideo(panelVideo, isLivePanel, accessToken);
    const requiresAuthVod =
      !isLivePanel &&
      panelVideo?.requiresMVPDAuth &&
      getAuthForPanelVideo(panelVideo, isLivePanel, accessToken);
    if (panelVideo) {
      panelVideo.requiresAuthLive = requiresAuthLive;
      panelVideo.requiresAuth = requiresAuthVod;
    }

    const fetchedVideo = video || panelVideo;
    const defaultVideoContainerProps = this.getDefaultVideoContainerProps(fetchedVideo);
    const dma = getDmaFromVideo(panelVideo);
    const isContextPlayer =
      portalRef === 'context-player-video-portal' && document.getElementById(portalRef);
    const nextVideoId = nextVideos?.[0]?.id;
    const nextVideoPath = nextVideoId
      ? `${window.location.origin}${helperGetVideoUrl(nextVideoId)}`
      : null;
    const containerProps = {
      ...defaultVideoContainerProps,
      accessToken,
      dma,
      isFreemium,
      isFullscreen,
      nextVideoPath,
      panelVideo,
      playerReference,
      portalRef,
      retryErrors,
      retryFetchVideo: () => {
        const { fetchVideo, accessToken, deviceId, panelVideo } = this.props;
        const screenUrl = this.getScreenUrl(panelVideo);
        const panelType = _.get(panelVideo, '@type');
        const videoGuid = _.get(panelVideo, 'guid');
        const audioOnly = _.get(panelVideo, 'audioOnly');
        const isLivePanel = isLive(panelType);
        fetchVideo({
          url: screenUrl,
          isLive: isLivePanel,
          accessToken,
          deviceId,
          videoGuid,
          audioOnly,
          isFreemium,
          panelVideo,
        });
      },
      subscriptionPaused,
      subscription,
      isNationDigitalChannel,
    };

    const renderVideoContainer = ({ props, endCards, videoDetail }) => (
      <VideoContainer {...containerProps} {...props} endCards={endCards} videoDetail={videoDetail}>
        <Video />
      </VideoContainer>
    );
    const dynamicRating = this.renderDynamicRating(fetchedVideo);
    const contextProps = {
      ...this.props,
      ...this.state,
      defaultPlayerEvents: this.getDefaultPlayerEvents(),
      fetchedVideo,
      floodlightEvent: this.floodlightEvent,
      isContextPlayer,
      isFreemium,
      page,
      playerContext,
      playerReference,
      renderVideoContainer,
      setPlayerDataHover: this.setPlayerDataHover,
      setPlayerState: this.setPlayerState,
      setStickyControls: this.setStickyControls,
      isFullscreen,
      containerId: CONTAINER_ID,
    };

    let contextPlayer;
    switch (playerContext) {
      case PLAYER_CONTEXT_WATCH:
        contextPlayer = <WatchContext {...contextProps} />;
        break;
      case PLAYER_CONTEXT_LIVE:
        contextPlayer = <LiveContext {...contextProps} />;
        break;
      default:
        break;
    }
    return (
      <div
        ref={videoContainerEl => {
          this.videoContainerEl = videoContainerEl;
        }}
        className={theme.videoContainerWrapper}
        id={CONTAINER_ID}
        onMouseEnter={() => this.setState({ stickyControls: true })}
        onMouseLeave={() => this.setState({ stickyControls: false })}
      >
        {dynamicRating}
        <div className={theme.shadowOverlay} />
        {contextPlayer}
      </div>
    );
  };

  onWindowResize = _.debounce(() => {
    if (this.videoContainerEl) {
      this.setState({ videoContainerHeight: this.videoContainerEl.clientHeight });
    }
  }, DEBOUNCE_TIME);

  render() {
    const {
      account,
      breakpoint,
      disableRender,
      episodes,
      isLivePage,
      originalItem,
      panelVideo,
      playerType,
      portalRef,
      streamExit,
      panels,
      recommendationIdData,
    } = this.props;
    const {
      firstFramePlayed,
      isAuthError,
      isNationDigitalChannel,
      theme,
      videoContainerHeight,
    } = this.state;
    const networksBar = window.ExternalConfig.networkNavigation;
    const currentPath = _.get(this.props, 'location.pathname');
    if (disableRender || streamExit) return null;
    const isMobile = isMobileBreakpoint(breakpoint);
    const isLiveNationDigital =
      isLivePage && currentPath.includes('live-news') && isNationDigitalChannel;
    const nationDigitalContainerClass = isLiveNationDigital && theme.nationDigitalVideoContainer;
    const nationDigitalClass = isLiveNationDigital && theme.nationDigitalVideo;
    const hide = isPlayerTypeHero(playerType) && (!firstFramePlayed || isMobile || isAuthError);
    const hideContainerClass = hide && theme.hide;
    const videoPlayer = this.renderPlayer();
    const containerPaddingClass = networksBar ? theme.withNetworksBar : '';
    const isPlaylistVariantActive = getPlaylistVariantActive({ panelVideo });

    const videoPlayerGlobal = (
      <div
        className={classNames(
          theme.container,
          hideContainerClass,
          containerPaddingClass,
          nationDigitalContainerClass,
          isEpgv2Enabled() ? theme.resizablePlayer : null,
          isPlaylistVariantActive ? theme.playlistContainer : null,
        )}
      >
        <div className={theme.overlay} />
        <div className={classNames(theme.innerContainer, nationDigitalClass)}>
          {videoPlayer}
          {isPlaylistVariantActive && (
            <VideoPlaylist
              account={account}
              breakpoint={breakpoint}
              episodes={episodes}
              originalItem={originalItem}
              panels={panels}
              initialEpisodes={new Array(...episodes)}
              panelVideo={panelVideo}
              recommendationIdData={recommendationIdData}
              setRecommendationId={setRecommendationId}
              theme={theme}
              videoContainerHeight={videoContainerHeight}
            />
          )}
          <WindowResizeListener DEBOUNCE_TIME={DEBOUNCE_TIME} onResize={this.onWindowResize} />
        </div>
      </div>
    );
    const portalLocation = document.getElementById(portalRef);
    return portalRef && portalLocation
      ? ReactDOM.createPortal(videoPlayerGlobal, portalLocation)
      : videoPlayerGlobal;
  }
}

function mapStateToProps({ globalVideo, app, seriesDetail, watch }) {
  const globalVideoProps = _.pick(globalVideo, [
    'disableRender',
    'errors',
    'hideVideoUntilPlayback',
    'isLiveRestart',
    'isVodUnavailable',
    'nextVideo',
    'nextVideos',
    'nextVideosValidFor',
    'originalItem',
    'page',
    'panelVideo',
    'playerContext',
    'playerType',
    'releaseUrl',
    'restartVideo',
    'retryErrors',
    'shouldResetStillWatching',
    'showControls',
    'startedPlayback',
    'streamExit',
    'video',
    'hasSeenHalfAnyVideo',
    'portalRef',
  ]);
  return {
    ...globalVideoProps,
    episodes: seriesDetail.episodes,
    seriesData: seriesDetail.seriesData,
    recommendationIdData: app.recommendationIdData,
    profile: app.profile,
    panels: watch.panels,
    subscription: app.subscription,
    subscriptionPaused: app.subscriptionPaused,
  };
}

export default connect(mapStateToProps, {
  clearNextVideosValidFor,
  clearPercentWatched,
  clearVideo,
  fetchNextVideo,
  fetchUpNext,
  fetchVideo,
  fetchVideoPanel,
  forceCollectionKeyartForShowcase,
  playNextPlaylistVideo,
  resetVodSectionClicked,
  saveLiveRestart,
  savePercentWatched,
  setError,
  setHasSeenHalfAnyVideo,
  setPortalContentFinished,
  setRecommendationId,
  setStreamExit,
  setVideoPanel,
  setVideoStartedPlayback,
  updateShowcaseVideo,
})(ReactTimeout(VideoPlayerGlobal));

VideoPlayerGlobal.defaultProps = {
  accessToken: null,
  account: null,
  adblock: false,
  anonymousAccount: null,
  anonymousId: null,
  anonymousLogin: noop,
  authSuccess: false,
  blackoutConfig: null,
  blackoutDefinitions: null,
  clearTimeout: noop,
  coordinates: null,
  deviceId: null,
  episodes: null,
  errors: null,
  favoritesManager: null,
  hasSeenHalfAnyVideo: false,
  isAuthenticated: false,
  isFreemium: false,
  isHeader: false,
  isHomePage: false,
  isLivePage: false,
  isLiveRestart: false,
  isNavScheduleRendered: false,
  isPlayerLoaded: false,
  isStatic: false,
  isVodUnavailable: false,
  location: {},
  nextVideosValidFor: null,
  onAuthCheckComplete: noop,
  openSignIn: noop,
  openSignUp: noop,
  originalItem: {},
  page: null,
  panels: {},
  panelVideo: null,
  params: {},
  playerContext: null,
  playerType: null,
  playlistData: null,
  portalRef: '',
  preauthorizedResources: [],
  profile: noop,
  profileId: null,
  provider: {},
  recommendationIdData: null,
  reducerVideo: null,
  releaseUrl: null,
  renderVideoContainer: null,
  restartVideo: null,
  retryErrors: {},
  seo: null,
  setAccountCloseIgnoreRedirect: noop,
  setBlockMVPDIncomplete: noop,
  setHasSeenHalfAnyVideo: noop,
  setInterval: noop,
  setIsAuthenticated: false,
  setIsPlayerLoaded: false,
  setLoading: null,
  setMVPDToAppState: noop,
  setOverlay: false,
  setRecommendationId: noop,
  setTimeout: noop,
  shouldResetStillWatching: false,
  streamExit: false,
  subscription: null,
  subscriptionPaused: false,
  toggleMvpdAuthOverlay: noop,
  triggerAuthCheck: false,
  video: null,
};

VideoPlayerGlobal.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({ accessToken: PropTypes.string }),
  adblock: PropTypes.bool,
  anonymousAccount: PropTypes.shape({ accessToken: PropTypes.string }),
  anonymousId: PropTypes.string,
  anonymousLogin: PropTypes.func,
  authSuccess: PropTypes.bool,
  blackoutConfig: PropTypes.shape({}),
  blackoutDefinitions: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  clearNextVideosValidFor: PropTypes.func.isRequired,
  clearPercentWatched: PropTypes.func.isRequired,
  clearTimeout: PropTypes.func,
  clearVideo: PropTypes.func.isRequired,
  coordinates: PropTypes.shape({}),
  deviceId: PropTypes.string,
  disableRender: PropTypes.bool.isRequired,
  episodes: PropTypes.arrayOf(PropTypes.shape({})),
  errors: PropTypes.number,
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
    deleteFavorites: PropTypes.func.isRequired,
  }),
  fetchUpNext: PropTypes.func.isRequired,
  fetchVideo: PropTypes.func.isRequired,
  forceCollectionKeyartForShowcase: PropTypes.func.isRequired,
  getUseUtagGlobal: PropTypes.func.isRequired,
  hasSeenHalfAnyVideo: PropTypes.bool,
  hideVideoUntilPlayback: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool,
  isFreemium: PropTypes.bool,
  isHeader: PropTypes.bool,
  isHomePage: PropTypes.bool,
  isLiveRestart: PropTypes.bool,
  isLivePage: PropTypes.bool,
  isNavScheduleRendered: PropTypes.bool,
  isPlayerLoaded: PropTypes.bool,
  isStatic: PropTypes.bool,
  isVodUnavailable: PropTypes.bool,
  location: PropTypes.shape({}),
  nextVideos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  nextVideosValidFor: PropTypes.number,
  onAuthCheckComplete: PropTypes.func,
  openSignIn: PropTypes.func,
  openSignUp: PropTypes.func,
  originalItem: PropTypes.shape({}),
  page: PropTypes.string,
  pageViewEvent: PropTypes.func.isRequired,
  playNextPlaylistVideo: PropTypes.func.isRequired,
  playerType: PropTypes.string,
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  panelVideo: PropTypes.shape({}),
  params: PropTypes.shape({ videoId: PropTypes.string }),
  playerContext: PropTypes.string,
  playlistData: PropTypes.shape({}),
  portalRef: PropTypes.string,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  profile: PropTypes.shape({}),
  profileId: PropTypes.string,
  provider: PropTypes.shape({}),
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  reducerVideo: PropTypes.shape({}),
  releaseUrl: PropTypes.string,
  renderAuthContainer: PropTypes.func.isRequired,
  renderVideoContainer: PropTypes.func,
  resetVodSectionClicked: PropTypes.func.isRequired,
  restartVideo: PropTypes.shape({}),
  retryErrors: PropTypes.shape({}),
  seo: PropTypes.shape({}),
  setAccountCloseIgnoreRedirect: PropTypes.func,
  setAuthorizationToken: PropTypes.func.isRequired,
  setBlockMVPDIncomplete: PropTypes.func,
  setHasSeenHalfAnyVideo: PropTypes.func,
  setInterval: PropTypes.func,
  setIsAuthenticated: PropTypes.func,
  setIsPlayerLoaded: PropTypes.func,
  setLoading: PropTypes.func,
  setMVPDToAppState: PropTypes.func,
  setOverlay: PropTypes.func,
  setProvider: PropTypes.func.isRequired,
  setRecommendationId: PropTypes.func,
  setTimeout: PropTypes.func,
  setVideoPanel: PropTypes.func.isRequired,
  setVideoStartedPlayback: PropTypes.func.isRequired,
  shouldResetStillWatching: PropTypes.bool,
  startedPlayback: PropTypes.bool.isRequired,
  streamExit: PropTypes.bool,
  subscriptionPaused: PropTypes.bool,
  subscription: PropTypes.shape({}),
  toggleMvpdAuthOverlay: PropTypes.func,
  triggerAuthCheck: PropTypes.bool,
  video: PropTypes.shape({}),
};
